import { schema } from 'normalizr';

const notification = new schema.Entity('notifications');

export default notification;
export const notificationList = [notification];
